export default {
  'menu.workbench': 'ようこそ',
  'menu.platform-knowledge-graph.dashboard': 'ダッシュボード',
  'menu.platform-knowledge-graph.ontology': 'オントロジー管理',
  'menu.platform-knowledge-graph.ontology.entity-types':
    'エンティティタイプ管理',
  'menu.platform-knowledge-graph.ontology.relation-types': '関係タイプ管理',
  'menu.platform-knowledge-graph.ontology.schema-view':
    'オントロジー構造ビュー',
  'menu.platform-knowledge-graph.entities': 'プラットフォームエンティティ',
  'menu.platform-knowledge-graph.entities.list': '全エンティティ',
  'menu.platform-knowledge-graph.entities.companies': '企業エンティティ',
  'menu.platform-knowledge-graph.entities.persons': '人物エンティティ',
  'menu.platform-knowledge-graph.entities.products': '製品エンティティ',
  'menu.platform-knowledge-graph.entities.policies': '政策エンティティ',
  'menu.platform-knowledge-graph.entities.industries': '業界エンティティ',
  'menu.platform-knowledge-graph.entities.technologies': '技術エンティティ',
  'menu.platform-knowledge-graph.entities.brands': 'ブランドエンティティ',
  'menu.platform-knowledge-graph.entities.regions': '地域エンティティ',
  'menu.platform-knowledge-graph.entities.organizations': '組織エンティティ',
  'menu.platform-knowledge-graph.entities.standards': '標準エンティティ',
  'menu.platform-knowledge-graph.entities.regulations': '法規エンティティ',
  'menu.platform-knowledge-graph.entities.events': 'イベントエンティティ',
  'menu.platform-knowledge-graph.entities.websites': 'Webサイトエンティティ',
  'menu.platform-knowledge-graph.entities.web-pages': 'Webページエンティティ',
  'menu.platform-knowledge-graph.entities.articles': '記事エンティティ',
  'menu.platform-knowledge-graph.entities.tags': 'タグエンティティ',
  'menu.platform-knowledge-graph.entities.concepts': '概念エンティティ',
  'menu.platform-knowledge-graph.relations': 'プラットフォーム関係庫',
  'menu.platform-knowledge-graph.graph': 'グラフ可視化',
  'menu.platform-knowledge-graph.governance': 'データガバナンス',
  'menu.platform-knowledge-graph.governance.deduplication':
    'エンティティ重複排除',
  'menu.platform-knowledge-graph.governance.mapping': 'エンティティマッピング',
  'menu.platform-knowledge-graph.governance.merge-logs': '統合履歴',
  'menu.platform-knowledge-graph.import': 'データインポート',
  'menu.platform-knowledge-graph.import.data-sources': 'データソース管理',
  'menu.platform-knowledge-graph.import.tasks': 'インポートタスク',
  'menu.platform-knowledge-graph.open-settings': '公開設定',
  'menu.platform-knowledge-graph.settings': 'システム設定',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': '設定',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
